import { createMiddleware, createStart } from "@tanstack/react-start";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const rejectUnsupportedMcpMethods = createMiddleware().server(async ({ next, request }) => {
  const { pathname } = new URL(request.url);
  if (pathname === "/mcp" && (request.method === "GET" || request.method === "DELETE")) {
    return new Response(JSON.stringify({ error: "method not allowed" }), {
      status: 405,
      headers: {
        Allow: "POST, OPTIONS",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Expose-Headers":
          "WWW-Authenticate, Mcp-Session-Id, Mcp-Protocol-Version",
      },
    });
  }
  return next();
});

export const startInstance = createStart(() => ({
  requestMiddleware: [rejectUnsupportedMcpMethods],
  functionMiddleware: [attachSupabaseAuth],
}));